/**
 * Brand mark — italic Fraunces "f" + small-caps name. Used in headers everywhere.
 */
export function Brand({ subtitle }: { subtitle?: string }) {
  return (
    <div className="flex items-baseline gap-3">
      <span
        className="font-display italic text-2xl text-moss leading-none"
        style={{ fontVariationSettings: '"opsz" 144, "SOFT" 100' }}
      >
        f
      </span>
      <span className="eyebrow">FitTrack{subtitle ? ` · ${subtitle}` : ""}</span>
    </div>
  )
}
